import React from 'react';
import "./AboutPage.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import {about_us,About_Us_Text} from "../../data";
import MultiCarousel from "../../Common/LogoCarousel"
import Founder from "../../Common/Founder";



function App() {
  return <X02AboutPageTablet {...x02AboutPageTabletData} />;
}

export default App;

function X02AboutPageTablet(props) {
  const {
    aboutUs,
    rectangle76,
    text8,
    text82,
    text83,
    text84,
    text85,
    text86,
    text87,
    whyChooseUs,
    line55,
    vector2,
    vector3,
    place,
    vector4,
    vector5,
    cost,
    vector6,
    vector7,
    vector8,
    vector9,
    vector10,
    vector11,
    vector12,
    vector13,
    vector14,
    vector15,
    vector16,
    vector17,
    vector18,
    vector19,
    vector20,
    vector21,
    vector22,
    vector23,
    overlapGroup4,
    vector24,
    vector25,
    vector26,
    vector27,
    vector28,
    vector29,
    vector30,
    vector31,
    vector32,
    group,
    vector33,
    vector34,
    vector35,
    vector36,
    vector37,
    vector38,
    vector39,
    vector40,
    vector41,
    vector42,
    transparency,
    rectangle72,
    place2,
    text10,
    rectangle73,
    transparenccy,
    text11,
    rectangle70,
    cost2,
    text12,
    rectangle77,
    title,
    text9,
    founders,
    frame144Props,
    founderCardProps,
    founderCard2Props,
    founderCardProps2,
    founderCard2Props2,
    frame165Props,
    //footerProps,
  } = props;

  return (
    <div className="apt-container-center-horizontal">
      <div className="apt-x02-about-page-tablet apt-screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <div className="apt-about-us apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{aboutUs}</div>
        {/* <img className="apt-rectangle-76" src={rectangle76} /> */}
        <img className="apt-rectangle-76" src={about_us.AboutUsHeader} alt="Webuildd About Us"/> 
        <div className="apt-vision-mission">
        <p> Vision Statement : To accelerate and furnish your ideal space through quality innovation.</p>
          <p> Mission Statement : Constructing dreams transparently, at an effective cost with quality, just as we promised. </p>
        </div>
        <div className="apt-text-1 apt-typography-body-smalltext-14-regular">
          <p>{text8}</p>
          <p>{text82}</p>
          <p>{text83}</p>
          <p>{text84}</p>
          <p>{text85}</p>
          <p>{text86}</p>
          <p>{text87}</p>
        </div>
        <div className="apt-why-choose-us apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{whyChooseUs}</div>
        <div className="apt-group-154">
          <div className="apt-overlap-group">
            <img className="apt-line-55" src={line55} />
            <div className="apt-group-151">
              {/* <div className="apt-group-14 apt-border-1px-red">
                <div className="apt-quality">
                  <div className="apt-overlap-group1">
                    <img
                      className="apt-vector-1"
                      src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-59@2x.svg"
                    />
                    <img className="apt-vector-2" src={vector2} />
                    <img className="apt-vector" src={vector3} />
                  </div>
                </div>
              </div> */}
                {/* <img 
                  src='https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/releases/60d434f90f59a872fbd1cefc/img/qualiyty@2x.svg'
                  width='124px'
                  height='124px'
                /> */}
                <img 
                  src={about_us.AboutQualityIcon}
                  width='124px'
                  height='124px'
                />
              <div className="apt-place apt-valign-text-middle apt-typographyheadlineh5-extrabold-20">{place}</div>
            </div>
            <div className="apt-group-153">
              {/* <div className="apt-group-14 apt-border-1px-red">
                <div className="apt-money-bag">
                  <div className="apt-overlap-group1-1">
                    <img className="apt-vector-3" src={vector4} />
                    <img className="apt-vector" src={vector5} />
                  </div>
                </div>
              </div> */}
              <img 
              src={about_us.AboutCostIcon}
              width='124px'
              height='124px'
              />
              <div className="apt-cost apt-valign-text-middle apt-typographyheadlineh5-extrabold-20">{cost}</div>
            </div>
            <div className="apt-group-152">
              {/* <div className="apt-group-150 apt-border-1px-red">
                <div className="apt-overlap-group6">
                  <div className="apt-overlap-group1-2">
                    <div className="apt-group">
                      <div className="apt-overlap-group3">
                        <img className="apt-vector-4" src={vector6} />
                        <img className="apt-vector-5" src={vector7} />
                        <img className="apt-vector-6" src={vector8} />
                        <img className="apt-vector-7" src={vector9} />
                        <img className="apt-vector-8" src={vector10} />
                        <img className="apt-vector-9" src={vector11} />
                        <img className="apt-vector-10" src={vector12} />
                        <img className="apt-vector-11" src={vector13} />
                        <img className="apt-vector-12" src={vector14} />
                        <img className="apt-vector-13" src={vector15} />
                        <img className="apt-vector-14" src={vector16} />
                        <img className="apt-vector-15" src={vector17} />
                        <img className="apt-vector-16" src={vector18} />
                        <img className="apt-vector-17" src={vector19} />
                        <img className="apt-vector-18" src={vector20} />
                        <img className="apt-vector-19" src={vector21} />
                        <img className="apt-vector-20" src={vector22} />
                        <img className="apt-vector-21" src={vector23} />
                      </div>
                      <div className="apt-overlap-group4" style={{ backgroundImage: `url(${overlapGroup4})` }}>
                        <img className="apt-vector-22" src={vector24} />
                      </div>
                    </div>
                    <img className="apt-vector-23" src={vector25} />
                    <img className="apt-vector-24" src={vector26} />
                    <img className="apt-vector-25" src={vector27} />
                    <img className="apt-vector-26" src={vector28} />
                    <img className="apt-vector-27" src={vector29} />
                    <img className="apt-vector-28" src={vector30} />
                    <img className="apt-vector-29" src={vector31} />
                  </div>
                  <div className="apt-overlap-group2">
                    <img className="apt-vector-30" src={vector32} />
                    <div className="apt-group-1" style={{ backgroundImage: `url(${group})` }}></div>
                    <img className="apt-vector-31" src={vector33} />
                    <img className="apt-vector-32" src={vector34} />
                    <img className="apt-vector-33" src={vector35} />
                  </div>
                </div>
                <div className="apt-group-2">
                  <div className="apt-overlap-group5">
                    <img className="apt-vector-34" src={vector36} />
                    <img className="apt-vector-35" src={vector37} />
                    <img className="apt-vector-36" src={vector38} />
                    <img className="apt-vector-37" src={vector39} />
                    <img className="apt-vector-38" src={vector40} />
                    <img className="apt-vector-39" src={vector41} />
                    <img className="apt-vector-40" src={vector42} />
                  </div>
                </div>
              </div> */}
              <img 
              src={about_us.AboutTransparencyIcon}
              width='124px'
              height='124px'
              />
              <div className="apt-transparency apt-valign-text-middle apt-typographyheadlineh5-extrabold-20">{transparency}</div>
            </div>
          </div>
        </div>
        <div className="apt-group-144">
          {/* <img className="apt-rectangle-7" src={rectangle72} /> */}
          <img className="apt-rectangle-7" src={about_us.AboutQuality} alt="Webuildd Quality" />

          <div className="apt-group-143">
            <div className="apt-place-1 apt-valign-text-middle apt-overpass-extra-bold-shark-32px">{place2}</div>
            <p className="apt-text-3 apt-typography-body-smalltext-14-regular">{text10}</p>
          </div>
        </div>
        <div className="apt-group-142">
          {/* <img className="apt-rectangle-7" src={rectangle73} /> */}
          <img className="apt-rectangle-7" src={about_us.AboutTransparency} alt="Webuildd Transparency" />
          
          <div className="apt-group-145">
            <div className="apt-transparenccy apt-overpass-extra-bold-shark-32px">{transparenccy}</div>
            <p className="apt-text-4 apt-typography-body-smalltext-14-regular">{text11}</p>
          </div>
        </div>
        {/* <img className="apt-rectangle-70" src={rectangle70} /> */}
        <img className="apt-rectangle-70" src={about_us.AboutCost} alt="Webuildd Cost" />
        
        <div className="apt-group-146">
          <div className="apt-cost-1 apt-valign-text-middle apt-overpass-extra-bold-shark-32px">{cost2}</div>
          <p className="apt-text-5 apt-typography-body-smalltext-14-regular">{text12}</p>
        </div>

        <div className="apt-group-144">
          {/* <img className="apt-rectangle-7" src={rectangle72} /> */}
          <img className="apt-rectangle-7" src={about_us.Experience} alt="Webuildd Quality" />

          <div className="apt-group-143">
            <div className="apt-place-1 apt-valign-text-middle apt-overpass-extra-bold-shark-32px">{About_Us_Text.Experience_Text_Head}</div>
            <p className="apt-text-3 apt-typography-body-smalltext-14-regular">{About_Us_Text.Experience_Text}</p>
          </div>
        </div>
        <div className="apt-group-142">
          {/* <img className="apt-rectangle-7" src={rectangle73} /> */}
          <img className="apt-rectangle-7" src={about_us.Warranty} alt="Webuildd Transparency" />
          
          <div className="apt-group-145">
            <div className="apt-transparenccy apt-overpass-extra-bold-shark-32px">{About_Us_Text.Warranty_Text_Head}</div>
            <p className="apt-text-4 apt-typography-body-smalltext-14-regular">{About_Us_Text.Warranty_Text}</p>
          </div>
        </div>

        <div className="apt-group-144">
          {/* <img className="apt-rectangle-7" src={rectangle72} /> */}
          <img className="apt-rectangle-7" src={about_us.Completion} alt="Webuildd Quality" />

          <div className="apt-group-143">
            <div className="apt-place-1 apt-valign-text-middle apt-overpass-extra-bold-shark-32px">{About_Us_Text.Completion_Text_Head}</div>
            <p className="apt-text-3 apt-typography-body-smalltext-14-regular">{About_Us_Text.Completion_Text}</p>
          </div>
        </div>
        <div className="apt-group-142">
          {/* <img className="apt-rectangle-7" src={rectangle73} /> */}
          <img className="apt-rectangle-7" src={about_us.SOPC} alt="Webuildd Transparency" />
          
          <div className="apt-group-145">
            <div className="apt-transparenccy apt-overpass-extra-bold-shark-32px">{About_Us_Text.SOPC_Text_Head}</div>
            <p className="apt-text-4 apt-typography-body-smalltext-14-regular">{About_Us_Text.SOPC_Text}</p>
          </div>
        </div>
        {/* <img className="apt-rectangle-77" src={rectangle77} /> */}
        {/* <img className="apt-rectangle-77" src={about_us.AboutHowItWorks} /> */}
        

        {/* <div className="apt-group-155">
          <h1 className="apt-title apt-valign-text-middle apt-typographyheadlineh2-extrabold-40">{title}</h1>
          <p className="apt-text-2 apt-typographybody16-regular">{text9}</p>
        </div> */}
        <div className="apt-founders apt-valign-text-middle apt-typographyheadlineh2-extrabold-40">{founders}</div>
        {/* <div className="apt-flex-row">
          <FounderCard
            rectangle90={founderCardProps.rectangle90}
            name={founderCardProps.name}
            designation={founderCardProps.designation}
          />
          <FounderCard2
            rectangle90={founderCard2Props.rectangle90}
            name={founderCard2Props.name}
            designation={founderCard2Props.designation}
          />
        </div>
        <div className="apt-flex-row-1">
          <FounderCard32
            rectangle90={founderCardProps2.rectangle90}
            name={founderCardProps2.name}
            designation={founderCardProps2.designation}
          />
          <FounderCard4
            rectangle90={founderCard2Props2.rectangle90}
            name={founderCard2Props2.name}
            designation={founderCard2Props2.designation}
          />
        </div> */}
        <Founder/>
        {/* <Frame165
          image3={frame165Props.image3}
          image5={frame165Props.image5}
          image4={frame165Props.image4}
          image6={frame165Props.image6}
          image8={frame165Props.image8}
          image7={frame165Props.image7}
        /> */}
        <div style={{backgroundColor:'white',width:'100%', marginTop:"60px"}}>
        <MultiCarousel/>
        </div>
        {/* <Footer {...footerProps} /> */}
        <Footer />
      </div>
      
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="apt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="apt-group-86">
      <White src={whiteProps.src} />
      <img className="apt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="apt-white">
      <img className="apt-vector-41" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="apt-icon-menu">
      <img
        className="apt-vector-43"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="apt-vector-42" src={vector2} />
      <img className="apt-vector-42" src={vector3} />
    </div>
  );
}


function FounderCard(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apt-founder-card">
      <img className="apt-rectangle-90" src={rectangle90} />
      <div className="apt-group-99">
        <div className="apt-name apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apt-designation apt-typography-body-smalltext-14-regular">{designation}</div>
      </div>

    </div>
  );
}


function FounderCard2(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apt-founder-card-1">
      <img className="apt-rectangle-90-1" src={rectangle90} />
      <div className="apt-group-99-1">
        <div className="apt-name-1 apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apt-designation-1 apt-typography-body-smalltext-14-regular">{designation}</div>
      </div>

      
    </div>
  );
}


function FounderCard32(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apt-founder-card-2">
      <img className="apt-rectangle-90-2" src={rectangle90} />
      <div className="apt-group-99-2">
        <div className="apt-name-2 apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apt-designation-2 apt-typography-body-smalltext-14-regular">{designation}</div>
      </div>
    </div>
  );
}


function FounderCard4(props) {
  const { rectangle90, name, designation } = props;

  return (
    <div className="apt-founder-card-3">
      <img className="apt-rectangle-90-3" src={rectangle90} />
      <div className="apt-group-99-3">
        <div className="apt-name-3 apt-valign-text-middle apt-typographyheadlineh4-extrabold-24">{name}</div>
        <div className="apt-designation-3 apt-typography-body-smalltext-14-regular">{designation}</div>
      </div>

    </div>
  );
}


function Frame165(props) {
  const { image3, image5, image4, image6, image8, image7 } = props;

  return (
    <div className="apt-frame-165">
      {/* <img className="apt-image-3" src={image3} />
      <img className="apt-image" src={image5} />
      <img className="apt-image" src={image4} />
      <img className="apt-image" src={image6} />
      <img className="apt-image" src={image8} />
      <img className="apt-image" src={image7} /> */}

      <img className="apt-image-3" src={about_us.GreyBG1} />
      <img className="apt-image" src={about_us.GreyBG2} />
      <img className="apt-image" src={about_us.GreyBG3} />
      <img className="apt-image" src={about_us.GreyBG4} />
      <img className="apt-image" src={about_us.GreyBG5} />
      <img className="apt-image" src={about_us.GreyBG6} />      
    </div>
  );
}


// function Footer(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text42,
//     text3,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group87Props,
//   } = props;

//   return (
//     <div className="apt-footer">
//       <div className="apt-flex-row-3">
//         <img
//           className="apt-vector-44"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="apt-group-85-1" src={group85} />
//         <Group87
//           facebookAppSymbolProps={group87Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group87Props.facebookAppSymbolProps2}
//           twitterProps={group87Props.twitterProps}
//         />
//       </div>
//       <div className="apt-flex-row-4">
//         <div className="apt-group-32">
//           <div className="apt-place-2 apt-valign-text-middle apt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="apt-flex-row-5">
//             <div className="apt-flex-col">
//               <div className="apt-map-pin-1">
//                 <div className="apt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="apt-vector-45" src={vector2} />
//                 </div>
//               </div>
//               <div className="apt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="apt-mail">
//                 <div className="apt-overlap-group1-3" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="apt-vector-46" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="apt-flex-col-1">
//               <p className="apt-text-7 apt-typography-body-smalltext-14-regular">{text42}</p>
//               <div className="apt-flex-col-item apt-valign-text-middle apt-typography-body-smalltext-14-regular">{text3}</div>
//               <div className="apt-flex-col-item apt-valign-text-middle apt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="apt-group-147">
//           <div className="apt-quick-links apt-valign-text-middle apt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="apt-flex-row-6">
//             <div className="apt-about-us-1 apt-valign-text-middle apt-typographybody16-regular">{aboutUs}</div>
//             <div className="apt-projects apt-valign-text-middle apt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="apt-flex-row-2">
//             <div className="apt-gallery apt-valign-text-middle apt-typographybody16-regular">{gallery}</div>
//             <div className="apt-knowledge-transfer apt-valign-text-middle apt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="apt-flex-row-2">
//             <div className="apt-blogs apt-valign-text-middle apt-typographybody16-regular">{blogs}</div>
//             <div className="apt-fa-qs apt-valign-text-middle apt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group87(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="apt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram instagram={facebookAppSymbolProps2.instagram} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="apt-facebook-app-symbol">
      <img className="apt-f-1" src={src} />
    </div>
  );
}


function Instagram(props) {
  const { instagram, vector2 } = props;

  return (
    <div className="apt-instagram" style={{ backgroundImage: `url(${instagram})` }}>
      <div className="apt-overlap-group-2">
        <img
          className="apt-vector-47"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-110@2x.svg"
        />
        <img className="apt-vector-48" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="apt-twitter">
      <img className="apt-vector-49" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/WebuilddLogo.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const founderCardData = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90@2x.png",
    name: "Jenny Wilson",
    designation: "Designation",
};

const founderCard2Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-1@2x.png",
    name: "Brooklyn Simmons",
    designation: "Designation",
};

const founderCard32Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-2@2x.png",
    name: "Esther Howard",
    designation: "Designation",
};

const founderCard4Data = {
    rectangle90: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-90-3@2x.png",
    name: "Jane Cooper",
    designation: "Designation",
};

const frame165Data = {
    image3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-3-2@2x.png",
    image5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-5-2@2x.png",
    image4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-4-2@2x.png",
    image6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-3-2@2x.png",
    image8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-5-2@2x.png",
    image7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/image-4-2@2x.png",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagramData = {
    instagram: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-223@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-409@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-347@2x.svg",
};

const group87Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagramData,
    twitterProps: twitterData,
};

// const footerData = {
//     group85: "https://raw.githubusercontent.com/shiddugmail/smk-images/cddd5118ab9b721fb3fcb416b435f6886e587deb/Webuildd-Logo-White.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-275@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-108@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-151@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-110@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-111@2x.svg",
//     text42: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text3: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group87Props: group87Data,
// };

const x02AboutPageTabletData = {
    aboutUs: "About Us",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-4@1x.png",
    text8: "WeBuildd is a third-generation family-owned construction company located in Bangalore. As a fully integrated firm, we have our in-house team of Architects, Structural Engineers, Contractors/Builders, Interior Designers, and Consultants to make your visions come true.",
    text82:"With our strong technical knowledge in the construction industry, we have developed properties across all asset classes including, industrial, manufacturing, biotech, residential, healthcare, education, mixed‐use, and retail.",
    text83:"We have invested countless hours in the relentless pursuit of building better and smart homes and commercial properties through our quality-conscious, money-saving, thoughtful designs, as well as transparent, higher building standards.",
    text84:"Our objective has been to make the construction process enjoyable for our consumers since the beginning of our adventure.",
    text85:"We give the customers the ability to personalize their visions from floor plans and construction materials to furniture cabinets at a price that fits their budget without compromising the quality.",
    text86:"We also help our customers to sort through residential & commercial building requirements, ranging from government plan approvals, architectural plans, construction, io interior solutions.",
    text87:"To begin your journey with us, use our online construction calculator to get a glimpse into our process and the financials involved.",
    whyChooseUs: "Why Choose Us?",
    line55: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/line-55@1x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-60@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-61@2x.svg",
    place: "Quality",
    vector4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-62@2x.svg",
    vector5: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-63@2x.svg",
    cost: "Cost",
    vector6: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-64@2x.svg",
    vector7: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-65@2x.svg",
    vector8: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-66@2x.svg",
    vector9: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-67@2x.svg",
    vector10: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-68@2x.svg",
    vector11: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-72@2x.svg",
    vector12: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-73@2x.svg",
    vector13: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-74@2x.svg",
    vector14: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-75@2x.svg",
    vector15: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-76@2x.svg",
    vector16: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-77@2x.svg",
    vector17: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-75@2x.svg",
    vector18: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-79@2x.svg",
    vector19: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-80@2x.svg",
    vector20: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-81@2x.svg",
    vector21: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-82@2x.svg",
    vector22: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-83@2x.svg",
    vector23: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-81@2x.svg",
    overlapGroup4: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-85@2x.svg",
    vector24: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-86@2x.svg",
    vector25: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-87@2x.svg",
    vector26: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-88@2x.svg",
    vector27: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-89@2x.svg",
    vector28: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-90@2x.svg",
    vector29: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-91@2x.svg",
    vector30: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-92@2x.svg",
    vector31: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-93@2x.svg",
    vector32: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-101@2x.svg",
    group: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-102@2x.svg",
    vector33: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-103@2x.svg",
    vector34: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-104@2x.svg",
    vector35: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-105@2x.svg",
    vector36: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-94@2x.svg",
    vector37: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg",
    vector38: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-96@2x.svg",
    vector39: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-97@2x.svg",
    vector40: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-95@2x.svg",
    vector41: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-99@2x.svg",
    vector42: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-100@2x.svg",
    transparency: "Transparency",
    rectangle72: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-72-1@1x.png",
    place2: "Quality",
    text10: <>Quality for us, is not just using expensive brands of raw materials, it mainly involves three key points, <br /><ul><li>Right design.</li> <p>By understanding the geological condition of your site as a prerequisite, we provide the customized design for your homesite by adopting inputs from the soil testing that we perform for each construction site.</p><li>Right standard operating procedures.</li><p>Our SOPs ensure we achieve high efficiency, quality outputs, and uniformity of performance.</p><li>Customising the appropriate construction material for specific conditions.<p>  Each brand of construction material has its strengths and weaknesses. We provide suggestions at each stage for specific brands and types of material to use according to your unique condition.</p></li></ul></>,
    rectangle73: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-73-1@1x.png",
    transparenccy: "Transparency",
    text11: <ul><li>Start your WeBuildd experience by visiting our existing projects of your choice.</li><li>You will receive an extensive list of ongoing and completed projects as a reference.</li><li>Every raw material and process performed at the start is described in an elaborate contract.</li><li> Selection option and final call in your hands. We will have you accompany us to the store for the closing call regarding the type of sanitary fittings, tiles, marbles, paint color, and all other interior items.</li></ul>,
    rectangle70: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-70-1@1x.png",
    cost2: "Cost",
    text12: "We price you at the actuals, which means there is no premium or additional cost added from us.",
    rectangle77: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-77@1x.png",
    title: "How it Works?",
    text9: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing. There are many variations passages of Lorem as Ipsums available but the majority have suffered that alterations in that some form by injected humour or randomised words which don’t looks even slightly that believable. If you are Lorem as Ipsum  you need to be sure there isn’t anything as embarrassing. There are many variation of passages Lorem Ipsum available but the majority have suffered that a aalteration in that some form by injected humour or randomised words which don’t look even slightly the believable. If you are Lorem Ipsum you need to be sure there is not the anything of embarrassing. If you are Lorem Ipsums your need to be sure there as isn’t anything embarrassing.",
    founders: "Founders",
    frame144Props: frame144Data,
    founderCardProps: founderCardData,
    founderCard2Props: founderCard2Data,
    founderCardProps2: founderCard32Data,
    founderCard2Props2: founderCard4Data,
    frame165Props: frame165Data,
    //footerProps: footerData,
};

